export default __webpack_public_path__ + "static/media/svgcar.aca8c6a6.svg";